import React, { Suspense, useEffect } from "react";
import loadable from '@loadable/component';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import { APPLICATION_LOCAL_STORAGE } from "./common/constants/constants";
import { persistor, store } from "./redux/store";
import PublicRoutes from "./routes/routes";
import { taskusLogo } from "./assets";

// Material Imports
// import Grid from "@mui/material/Grid";
const Grid = loadable(() => import("@mui/material/Grid"));
// const Moment = loadable.lib(() => import('moment'))

const LoaderPulse = loadable(() => import('./components/pages/formUI/LoaderPulse'))

const App = () => {
  /*
    // Author: Yahya
    const cfToken = Cookies.get('CF_Authorization1');
    if (cfToken !== undefined)
    {
    //get cf token from cookie
    localStorage.setItem('cfAccessToken', cfToken);
    }
    else
    {
    get token from pingID
    */

  const valueTokenUrl = window.location.href;
  if (valueTokenUrl?.split("access_token=")[1] !== undefined) {
    localStorage.setItem(
      APPLICATION_LOCAL_STORAGE.PING_ACCESS_TOKEN,
      valueTokenUrl?.split("access_token=")[1]
    );
  }
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = `${taskusLogo}`;
  }, []);
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Suspense
          fallback={
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
              sx={{ minHeight: "100vh" }}
            >
              <Grid item xs={3}>
                <LoaderPulse />
              </Grid>
            </Grid>
          }
        >
          <BrowserRouter>
            <PublicRoutes />
          </BrowserRouter>
        </Suspense>
      </PersistGate>
    </Provider>
  );
};

export default App;
